<div class="MainContainer animated fadeIn">
    <div class="MainCompanyTitle" style="margin-bottom: 0;">
        <p class="SectionTitle" style="margin-top: 0%;">{{ 'TaxationSettings' | translate }}</p>
    </div>

    <div class="fullWidthContainer" style="padding-left: 3px; padding-right: 3px;">

        <div class="SearchCountryContainer">
            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                <mat-label>{{ 'SearchCountry' | translate }}</mat-label>
                <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm">
                <mat-icon matSuffix style="cursor: pointer;">search</mat-icon>
            </mat-form-field>
        </div>

        <div class="AccordionContainer">
            <mat-accordion>
                <mat-expansion-panel disabled>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ 'Country' | translate }}
                      </mat-panel-title>
                      <mat-panel-description>
                        {{ 'Partners.PartnerWindow.StateProvince' | translate }}
                      </mat-panel-description>
                      <mat-panel-description>
                        {{ 'Partners.PartnerWindow.City' | translate }}
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                  </mat-expansion-panel>
        
                <mat-expansion-panel *ngFor="let c of this.Countries; index as i" (opened)="GetCountryTaxations(c.ID);">
                  <mat-expansion-panel-header class="ExpandHeadder">
                    <mat-panel-title>
                      {{c.Name}}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{c.ShortName}}
                    </mat-panel-description>
                    <mat-panel-description>
                        {{c.IsMainCountry}}
                      </mat-panel-description>
                  </mat-expansion-panel-header>
        
                  <div *ngIf="!loading" style="margin-top: 20px;">
                  
                    <div class="TaxationTableRow">
                       <div class="TaxationTableCol">
                            {{'TaxType' | translate}}
                       </div>
                        <div class="TaxationTableCol" style="width: 10%;">
                            {{'Percentage' | translate}}
                       </div>
                        <div class="TaxationTableCol" style="width: 10%;">
                            {{'ValueTax' | translate}}
                       </div>
                        <div class="TaxationTableCol" style="width: 10%;">
                            {{'UpperYearlySalesThreshold' | translate}}
                       </div>
                        <div class="TaxationTableCol">
                            {{'FromAvailability' | translate}}
                       </div>
                        <div class="TaxationTableCol">
                            {{'ToAvailability' | translate}}
                       </div>
                       <div class="TaxationTableCol">
                           {{'Actions' | translate}}
                       </div>
                    </div>

                    <div class="fullWidthContainer" *ngFor="let t of c.Taxations; index as j;">
                        <div class="TaxationTableCol">
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'TaxType' | translate }}</mat-label>
                                <mat-select name="TaxType" [compareWith]="compareFn" [(ngModel)]="t.Type">
                                  <mat-option *ngFor="let type of this.TaxTypes" [value]="type">
                                    {{type.Name}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                       </div>
                        <div class="TaxationTableCol" style="width: 10%;">
                            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                                <mat-label>{{ 'Percentage' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'Percentage' | translate }}" autocomplete="off" [(ngModel)]="t.PercentageTaxation">
                            </mat-form-field>
                       </div>
                        <div class="TaxationTableCol" style="width: 10%;">
                            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                                <mat-label>{{ 'ValueTax' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'ValueTax' | translate }}" autocomplete="off" [(ngModel)]="t.ValueTaxation">
                            </mat-form-field>
                       </div>
                        <div class="TaxationTableCol" style="width: 10%;">
                            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                                <mat-label>{{ 'UpperYearlySalesThreshold' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'UpperYearlySalesThreshold' | translate }}" autocomplete="off" [(ngModel)]="t.UpperYearlyThreshold">
                            </mat-form-field>
                       </div>
                        <div class="TaxationTableCol">
                            <mat-form-field appearance="outline" class="fullWidthContainer">
                                <mat-label>{{ 'FromAvailability' | translate }}</mat-label>
                                <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="t.FromAvailability">
                                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                                <mat-datepicker #dp></mat-datepicker>
                              </mat-form-field>
                       </div>
                        <div class="TaxationTableCol">
                            <mat-form-field appearance="outline" class="fullWidthContainer">
                                <mat-label>{{ 'ToAvailability' | translate }}</mat-label>
                                <input matInput [matDatepicker]="dp2" [formControl]="ToDate" [(ngModel)]="t.ToAvailability">
                                <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                                <mat-datepicker #dp2></mat-datepicker>
                              </mat-form-field>
                       </div>
                       <div class="TaxationTableCol">
                          <button mat-raised-button color="primary" (click)="AddUpdateCountryTaxation(t);">
                            <i class="material-icons">save_alt</i>
                              {{ 'SaveButton' | translate }}
                            </button>
                       </div>
                    </div>

                    <div class="fullWidthContainer">
                        <button mat-raised-button *ngIf="NewTax == null;" (click)="InitializeNewTax(c);">
                            <i class="material-icons">add</i>
                              {{ 'AddNewTax' | translate }}
                        </button>

                        <div class="fullWidthContainer" *ngIf="NewTax != null;">
                            <div class="TaxationTableCol">
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ 'TaxType' | translate }}</mat-label>
                                    <mat-select name="TaxType" [compareWith]="compareFn" [(ngModel)]="NewTax.Type">
                                      <mat-option *ngFor="let type of this.TaxTypes" [value]="type">
                                        {{type.Name}}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                           </div>
                            <div class="TaxationTableCol" style="width: 10%;">
                                <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                                    <mat-label>{{ 'Percentage' | translate }}</mat-label>
                                    <input matInput placeholder="{{ 'Percentage' | translate }}" autocomplete="off" [(ngModel)]="NewTax.PercentageTaxation">
                                </mat-form-field>
                           </div>
                            <div class="TaxationTableCol" style="width: 10%;">
                                <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                                    <mat-label>{{ 'ValueTax' | translate }}</mat-label>
                                    <input matInput placeholder="{{ 'ValueTax' | translate }}" autocomplete="off" [(ngModel)]="NewTax.ValueTaxation">
                                </mat-form-field>
                           </div>
                            <div class="TaxationTableCol" style="width: 10%;">
                                <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                                    <mat-label>{{ 'UpperYearlySalesThreshold' | translate }}</mat-label>
                                    <input matInput placeholder="{{ 'UpperYearlySalesThreshold' | translate }}" autocomplete="off" [(ngModel)]="NewTax.UpperYearlyThreshold">
                                </mat-form-field>
                           </div>
                            <div class="TaxationTableCol">
                                <mat-form-field appearance="outline" class="fullWidthContainer">
                                    <mat-label>{{ 'FromAvailability' | translate }}</mat-label>
                                    <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="NewTax.FromAvailability">
                                    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                                    <mat-datepicker #dp></mat-datepicker>
                                  </mat-form-field>
                           </div>
                            <div class="TaxationTableCol">
                                <mat-form-field appearance="outline" class="fullWidthContainer">
                                    <mat-label>{{ 'ToAvailability' | translate }}</mat-label>
                                    <input matInput [matDatepicker]="dp2" [formControl]="ToDate" [(ngModel)]="NewTax.ToAvailability">
                                    <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                                    <mat-datepicker #dp2></mat-datepicker>
                                  </mat-form-field>
                           </div>
                           <div class="TaxationTableCol">
                              <button mat-raised-button color="primary" (click)="AddUpdateCountryTaxation(NewTax);">
                                <i class="material-icons">save_alt</i>
                                  {{ 'SaveButton' | translate }}
                                </button>
                           </div>
                        </div>
                    </div>
                   
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
        </div>
      </div>
</div>

    
    